import React, { useState, useRef } from "react";
import "./Calculator.css";
import { Input, message } from "antd";
import API_URL from "../../../constants/API_URL";
import axios from "axios";
import { GoPlus } from "react-icons/go";

export default function PosKeyboard(props) {
  const [value, setValue] = useState("");
  const [barcodeinput, setBarcodeinput] = useState("");
  const textInputRef = useRef(null);

  const buttons = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "C", "0", "⌫"];

  const processBarcode = (barcodeValue) => {
    if (!barcodeValue || barcodeValue.trim() === "") {
      message.warning(
        props.lang.PLEASE_ENTER_BARCODE || "الرجاء إدخال الباركود أولاً",
      );
      return;
    }

    axios({
      url: API_URL + "productByBarcode",
      method: "GET",
      params: {
        lang: localStorage.getItem("lang"),
        clientId: localStorage.getItem("clientId"),
        barcode: barcodeValue,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.data.length < 1) {
          message.error(props.lang.NO_PRODUCT_FOUND || "No Product found!");
          return;
        }

        if (res.data.length === 1 && res.data[0].isGroupProduct === false) {
          let headers = {
            Authorization:
              localStorage.getItem("tokenType") +
              " " +
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          };
          let authOptions = {
            url: API_URL + "createSaleOrderLine",
            method: "POST",
            data: {
              lang: localStorage.getItem("lang"),
              client: localStorage.getItem("clientId"),
              order: props.posStorage.orderId,
              product: res.data[0].id,
              isScaleProduct: res.data[0].isScaleProduct,
              qty: 1,
              uom: res.data[0].uomId,
              isGroupProduct: false,
              priceWithoutTax: res.data[0].priceWithoutTax,
              unitPrice: res.data[0].price,
              isOffer: res.data[0].isOffer,
              prodOffer: null,
              offerType: res.data[0].offerType,
              isAddProduct: false,
              actualPrice: res.data[0].price,
              isDiscount: false,
              items: [],
            },
            headers,
          };
          axios(authOptions).then((res) => {
            if (res.data.success) {
              if (props.getsaleOrderLine) {
                props.getsaleOrderLine();
              }
              message.success(
                props.lang.PRODUCT_ADDED_SUCCESS || "تم إضافة المنتج بنجاح",
              );
            } else {
              message.error(res.data.message);
            }
          });
          return;
        }

        if (res.data.length === 1 && res.data[0].isGroupProduct) {
          if (props.addProduct) {
            props.addProduct(res.data[0].id);
          }
          return;
        }

        if (res.data.length > 1) {
          message.info(
            props.lang.MULTIPLE_PRODUCTS_FOUND || "تم العثور على عدة منتجات",
          );
        }
      })
      .catch((e) => {
        message.error(props.lang.NO_PRODUCT_FOUND || "No Product found!");
      });
  };

  const clearInput = () => {
    setBarcodeinput("");
    setValue("");
    if (textInputRef.current && textInputRef.current.input) {
      textInputRef.current.input.value = "";
    }
  };

  const handleClick = (btn) => {
    let newValue;

    if (btn === "C") {
      clearInput();
      return;
    }

    if (btn === "⌫") {
      newValue = value.slice(0, -1);
      setValue(newValue);
      setBarcodeinput(newValue);

      if (textInputRef.current && textInputRef.current.input) {
        textInputRef.current.input.value = newValue;
      }
      return;
    }

    newValue = value + btn;
    setValue(newValue);
    setBarcodeinput(newValue);

    if (textInputRef.current && textInputRef.current.input) {
      textInputRef.current.input.value = newValue;
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      const currentBarcode = textInputRef.current.input.value || "";
      processBarcode(currentBarcode);
      clearInput();
    }
  };

  const handleAddButtonClick = () => {
    const currentBarcode = textInputRef.current.input.value || "";
    processBarcode(currentBarcode);
    clearInput();
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setBarcodeinput(newValue);
    setValue(newValue);
  };

  return (
    <div className="calculator-container">
      <div className="calculator">
        <Input
          ref={textInputRef}
          id="barcodeinput"
          onKeyPress={handleKeyPress}
          onChange={handleChange}
          value={barcodeinput}
          style={{ fontSize: "16px" }}
          type="text"
          placeholder={
            props.lang.BARCODE_PLACEHOLDER ||
            "اكتب الباركود هنا ثم اضغط على زر الإدخال"
          }
        />
        <div className="buttons">
          {buttons.map((btn, index) => (
            <button
              key={index}
              className={`btn ${
                btn === "⌫" ? "delete-btn" : btn === "C" ? "clear-btn" : ""
              }`}
              onClick={() => handleClick(btn)}
            >
              {btn}
            </button>
          ))}
        </div>
        <button
          className="calculator-add-button"
          onClick={handleAddButtonClick}
        >
          <span>{props.lang.ADD || "إضافة"}</span>
          <GoPlus />
        </button>
      </div>
    </div>
  );
}
